/**
 * /api/external/lifex/* の公開ルート定義 (middleware の session 認証を skip)
 *
 * 認証は route.ts 内の verifyLifexBearer (LIFEX_LOOKUP_SHARED_SECRET) で実施するため、
 * middleware の session 認証は skip させる。Bearer 認証なしのリクエストは
 * route.ts が 401 を返す設計。
 *
 * 関連:
 * - app/api/external/lifex/consumer-lookup/route.ts
 * - app/api/external/lifex/health/route.ts
 * - lib/integrations/lifex/lookup-auth.ts
 */

export const EXTERNAL_LIFEX_PUBLIC_PATHS = {
  pages: [] as const,
  apis: [
    '/api/external/lifex/consumer-lookup',
    '/api/external/lifex/consumer-lookup-batch',
    '/api/external/lifex/health',
  ] as const,
} as const
